import BottomNavbar from "./BottomNavbar";
import MiddleNavbar from "./MiddleNavbar";
import TopNavbar from "./TopNavbar";

const NavbarContainer = () => {
  return (
    <>
      <TopNavbar />
      <MiddleNavbar />
      <BottomNavbar />
    </>
  );
};

export default NavbarContainer;
